<style lang="scss" scoped>
.app {
	width: 100vw;
	height: 100vh;
}
</style>

<template>
	<div class="app">
		<el-config-provider :locale="i18nLocale" :button="config" :size="assemblySize">
			<router-view />
		</el-config-provider>
	</div>
</template>

<script setup lang="ts">
// 配置element中英文
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import type { ComponentSize } from 'element-plus'

// 配置element按钮文字中间是否有空格
const config = reactive({
	autoInsertSpace: false,
})
// element 语言配置
const language = ref('zh-cn')
const i18nLocale = computed(() => (language.value === 'zh-cn' ? zhCn : en))

// 配置全局组件大小 (small/default(medium)/large)
const assemblySize = computed((): ComponentSize => 'default')
</script>
